import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  hideAndNavigate(event) {
    event.preventDefault();

    // Hide the notification immediately
    this.element.classList.add("d-none");

    // Navigate to the notifications page
    const url = event.currentTarget.href;
    window.location.href = url;
  }
}
